'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _shortid = require('shortid');

var _shortid2 = _interopRequireDefault(_shortid);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _reactTransitionGroup = require('react-transition-group');

var _Dropdown = require('./Dropdown.style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var withExpansion = (0, _recompose.withState)('isExpanded', 'dropdown__handleExpansion', false);

var Dropdown = exports.Dropdown = function Dropdown(_ref) {
  var className = _ref.className,
      dropdown__handleExpansion = _ref.dropdown__handleExpansion,
      isExpanded = _ref.isExpanded,
      items = _ref.items,
      trigger = _ref.trigger,
      triggerLabel = _ref.triggerLabel,
      onExpanded = _ref.onExpanded,
      onCollapsed = _ref.onCollapsed;
  return _react2.default.createElement(
    'div',
    {
      className: className + ' menu',
      onClick: function onClick() {
        dropdown__handleExpansion(!isExpanded);
        if (!isExpanded && onExpanded) {
          onExpanded();
        }
        if (isExpanded && onCollapsed) {
          onCollapsed();
        }
      } },
    _react2.default.createElement(
      'div',
      { className: 'trigger' },
      trigger,
      triggerLabel
    ),
    _react2.default.createElement(
      _reactTransitionGroup.TransitionGroup,
      null,
      isExpanded && _react2.default.createElement(
        _reactTransitionGroup.CSSTransition,
        {
          timeout: 150,
          classNames: 'fade-in' },
        _react2.default.createElement(
          'div',
          { className: 'menuItems' },
          _react.Children.map(items, function (x) {
            return _react2.default.createElement(
              'div',
              { className: 'itemWrapper' },
              _react2.default.cloneElement(x, { className: ('className' in x.props ? x.props.className : '') + ' action', key: _shortid2.default.generate() })
            );
          })
        )
      )
    ),
    isExpanded && _react2.default.createElement('div', {
      className: 'handleOutsideClick',
      onClick: function onClick() {
        dropdown__handleExpansion(false);
        if (!isExpanded && onCollapsed) {
          onCollapsed();
        }
      } })
  );
};

Dropdown.propTypes = {
  /**
   * The className provided by glamorous, it makes the magic happen.
   * Integral to the glamorous library, which this library is built upon.
   */
  className: _propTypes2.default.string,
  /**
   * Internal fn to toggle dropDown expansion, called on trigger click
   */
  dropdown__handleExpansion: _propTypes2.default.func.isRequired,
  /**
   * bool that determines whether the dropdown is expanded
   */
  isExpanded: _propTypes2.default.bool.isRequired,
  /**
   * list of nodes to render within the expandable section of the dropdown
   */
  items: _propTypes2.default.arrayOf(_propTypes2.default.node),
  /**
   * a node that inherits the click handler which toggles dropdown menu expansion
   */
  trigger: _propTypes2.default.node,
  /**
   * a label for the trigger
   */
  triggerLabel: _propTypes2.default.string,
  /**
   * an optional callback that will be invoked on dropDown expand
   */
  onExpanded: _propTypes2.default.func,
  /**
   * an optional callback that will be invoked on dropDown collapse
   */
  onCollapsed: _propTypes2.default.func
};

exports.default = withExpansion((0, _glamorous2.default)(Dropdown)(_Dropdown.defaultStyle, _Dropdown.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Dropdown/Dropdown.js
// module id = 349
// module chunks = 0